import { render } from "./CartaDocumento.vue?vue&type=template&id=c0c82b6c&scoped=true"
import script from "./CartaDocumento.vue?vue&type=script&lang=js"
export * from "./CartaDocumento.vue?vue&type=script&lang=js"

import "./CartaDocumento.vue?vue&type=style&index=0&id=c0c82b6c&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\portalalumnos\\portalalumnos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0c82b6c"]])

export default __exports__